import { useEffect } from "react";
import { useScopedState } from "../hooks/useScopedState";
import { type ProfilePhotoState, profilePhotoService } from "../services/profilePhotoService";

export function useProfilePhotoSubscription(uid: string | undefined, enabled: boolean, service = profilePhotoService) {
  const [state, setState] = useScopedState<ProfilePhotoState | null>(JSON.stringify([uid, enabled]), null);
  useEffect(() => {
    if (!uid || !enabled) return;
    let active = true;
    let unsubscribe: (() => void) | undefined;
    const failed = () => {
      if (active) setState(null);
      console.warn("Unable to observe profile photo.");
    };
    try {
      unsubscribe = service.subscribe(uid, value => { if (active) setState(value); }, failed);
    } catch { failed(); }
    return () => { active = false; unsubscribe?.(); };
  }, [uid, enabled, service, setState]);
  return enabled && state?.uid === uid ? state : null;
}
